import { CLEAR_FIRST_LOAD } from 'Actions/GlobalMetaActions';

// Fix protocols in URLs
TopifyPresets.forumData.forumSite[0].f_url = fixUrlProtocol( TopifyPresets.forumData.forumSite[0].f_url );
TopifyPresets.forumData.forumSite[0].url = fixUrlProtocol( TopifyPresets.forumData.forumSite[0].url );

export const initialState = {
	firstLoad: true,
	forumSite: TopifyPresets.forumData.forumSite[0],
	forumInfo: TopifyPresets.forumData.forumInfo[0],
	initialRoute: TopifyPresets.embedRoute,
	initialId: TopifyPresets.embedId,
	secondayId: TopifyPresets.secondayId,
	userInfo: TopifyPresets.userInfo,
	ffUrl: fixUrlProtocol( TopifyPresets.ffUrl )
};

export function topifyPresets(state = initialState, action) {
	switch (action.type) {
		case CLEAR_FIRST_LOAD:
			return {
				...state,
				firstLoad: false,
				initialRoute: null,
				initialId: null,
				secondayId: null,
				userInfo: null
			};

		default :
			return state;
	}
}

function fixUrlProtocol( url ) {
	 return url.replace( /^http[s]*:[/]{2}/i, ('https:' === document.location.protocol ? 'https://' : 'http://') );
}



// WEBPACK FOOTER //
// ./src/reducers/topifypresets.js